// Callback.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Callback() {
    const navigate = useNavigate();

    useEffect(() => {
        const token = new URLSearchParams(window.location.search).get('token');
        if (token) {
            fetch(`${process.env.REACT_APP_PATH}/api/user/verify-token`, {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token }),
            }).then(async res => {
                if (res.ok) {
                    const data = await res.json();
                    console.log('Login verification response:', data);

                    // Add a small delay to ensure cookie is set properly
                    setTimeout(() => {
                        if (data.isNewUser) {
                            // New user - redirect to user type selection
                            navigate('/user-type-selection');
                        } else {
                            // Returning user - redirect to main dashboard
                            navigate('/main');
                        }
                    }, 100);
                } else {
                    console.error('Token verification failed:', res.status, res.statusText);
                    alert('Invalid or expired login link');
                    navigate('/user-login');
                }
            }).catch(err => {
                console.error('Token verification error:', err);
                alert('Network error during login');
                navigate('/user-login');
            });
        } else {
            alert('No token found in URL');
            navigate('/user-login');
        }
    }, [navigate]);

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
            <div className="bg-white shadow-lg rounded-lg p-8 max-w-md w-full text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                <h2 className="text-xl font-semibold text-gray-900 mb-2">Prihlasovanie...</h2>
                <p className="text-gray-600">Prosím čakajte, spracovávame vaše prihlásenie.</p>
            </div>
        </div>
    );
}
